import { Popover, PopoverContent, PopoverTrigger, cn } from "@portal/ui";
import { FileText } from "lucide-react";
import { useState } from "react";
import { IconList } from "../../components/IconPicker";
import { IconMark, iconOf } from "../../components/ServiceIcon";

/**
 * メモのアイコン(Notion のように題名の左に出す。ユーザー要望 2026-10-15)。値は外部リンクのアイコンと同じ
 * (絵文字、またはサービスのアイコン)。未設定(や読めない値)なら、共通の紙の絵を出す(一覧の頭をそろえる)。
 */
export function MemoIcon({ value, className }: { value: string; className?: string }) {
  const icon = iconOf(value);
  return icon ? (
    <IconMark icon={icon} className={cn("size-4 shrink-0 text-[15px]", className)} />
  ) : (
    <FileText
      aria-hidden="true"
      data-testid="memo-default-icon"
      className={cn("size-4 shrink-0 text-muted-foreground", className)}
    />
  );
}

/** アイコンを押すと、選ぶ一覧(絵文字・サービスのアイコン・「アイコンを外す」)が開く。 */
export function MemoIconPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (icon: string) => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    // ダイアログの中でもポップオーバーの中をスクロールできるよう modal にする
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={value ? "アイコンを変える" : "アイコンを付ける"}
          title={value ? "アイコンを変える" : "アイコンを付ける"}
          className="grid size-9 shrink-0 place-items-center rounded-md border hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        >
          <MemoIcon value={value} className="size-5 text-[20px]" />
        </button>
      </PopoverTrigger>
      <PopoverContent side="bottom" align="start" className="w-88 p-2">
        <IconList
          value={value}
          url=""
          showFavicon={false}
          onChange={(v) => {
            onChange(v);
            setOpen(false);
          }}
          onClear={() => {
            onChange("");
            setOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
